import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=63e7975f&scoped=true"
import script from "./Classification.vue?vue&type=script&lang=js"
export * from "./Classification.vue?vue&type=script&lang=js"
import style0 from "./Classification.vue?vue&type=style&index=0&id=63e7975f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7975f",
  null
  
)

export default component.exports